import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class OperationalGuard {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.checkAccess();
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    return this.checkAccess();
  }

  private checkAccess(): boolean {
    // These pages are granted by `bidsweb:operational`, and opened without it for the
    // Administrador global and the Administrador Bidscircle (G19). `bidsops:access` is the
    // Bidscircle Ops application -- a different project, administered separately -- and does
    // not open the operational area of this one. A login-farmacias session is judged by the grant
    // rather than by which domain its email is on, so an operational account need not be
    // @bidscircle.eu, which is what the legacy rule below assumes.
    if (this.authService.isSso) {
      if (this.authService.ssoOperationalAccess) {
        return true;
      }
      // Home, the same place the legacy rule sends a non-operational account: this app is
      // still theirs. A session that cannot open this app either is refused a step later by
      // RoleBasedRouteGuard, which signs it out and explains — sending it to the login page
      // from here would only bounce off LoginPageComponent and come back.
      this.router.navigate(['/']);
      return false;
    }

    const user = this.authService.currentUserValue;
    if (user?.email?.endsWith('@bidscircle.eu')) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
